import * as Rollbar from 'rollbar';

const rollbarConfig = {
  accessToken: '31e48d6526254d2089099404af72d635',
  captureUncaught: true,
  captureUnhandledRejections: true,
};

export function rollbarFactory() {
  return new Rollbar(rollbarConfig);
}

export function updateConfig(data) {
  rollbarConfig['payload'] = {
    person: {
      id: data.userId,
      username: data.username,
      email: data.email,
    },
    environment: data.env,
  };
}
